var LZString = function() {
    function r(r, e) {
        if (!o[r]) {
            o[r] = {};
            for (var n = 0; n < r.length; n++) o[r][r.charAt(n)] = n
        }
        return o[r][e]
    }
    var e = String.fromCharCode,
        n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$",
        o = {},
        a = {
            compressToBase64: function(r) {
                if (null == r) return "";
                var e = a._compress(r, 6, (function(r) {
                    return n.charAt(r)
                }));
                switch (e.length % 4) {
                    default:
                    case 0:
                        return e;
                    case 1:
                        return e + "===";
                    case 2:
                        return e + "==";
                    case 3:
                        return e + "="
                }
            },
            decompressFromBase64: function(e) {
                return null == e ? "" : "" == e ? null : a._decompress(e.length, 32, (function(t) {
                    return r(n, e.charAt(t))
                }))
            },
            compressToUTF16: function(r) {
                return null == r ? "" : a._compress(r, 15, (function(r) {
                    return e(r + 32)
                })) + " "
            },
            decompressFromUTF16: function(r) {
                return null == r ? "" : "" == r ? null : a._decompress(r.length, 16384, (function(e) {
                    return r.charCodeAt(e) - 32
                }))
            },
            compressToUint8Array: function(r) {
                for (var e = a.compress(r), n = new Uint8Array(2 * e.length), t = 0, o = e.length; o > t; t++) {
                    var i = e.charCodeAt(t);
                    n[2 * t] = i >>> 8, n[2 * t + 1] = i % 256
                }
                return n
            },
            decompressFromUint8Array: function(r) {
                if (null == r) return a.decompress(r);
                for (var n = new Array(r.length / 2), t = 0, o = n.length; o > t; t++) n[t] = 256 * r[2 * t] + r[2 * t + 1];
                var i = [];
                return n.forEach((function(r) {
                    i.push(e(r))
                })), a.decompress(i.join(""))
            },
            compressToEncodedURIComponent: function(r) {
                return null == r ? "" : a._compress(r, 6, (function(r) {
                    return t.charAt(r)
                }))
            },
            decompressFromEncodedURIComponent: function(e) {
                return null == e ? "" : "" == e ? null : (e = e.replace(/ /g, "+"), a._decompress(e.length, 32, (function(n) {
                    return r(t, e.charAt(n))
                })))
            },
            compress: function(r) {
                return a._compress(r, 16, (function(r) {
                    return e(r)
                }))
            },
            _compress: function(r, e, n) {
                if (null == r) return "";
                var t, o, a, i = {},
                    s = {},
                    c = "",
                    p = "",
                    u = "",
                    l = 2,
                    h = 3,
                    f = 2,
                    d = [],
                    m = 0,
                    v = 0;
                for (a = 0; a < r.length; a += 1)
                    if (c = r.charAt(a), Object.prototype.hasOwnProperty.call(i, c) || (i[c] = h++, s[c] = !0), p = u + c, Object.prototype.hasOwnProperty.call(i, p)) u = p;
                    else {
                        if (Object.prototype.hasOwnProperty.call(s, u)) {
                            if (u.charCodeAt(0) < 256) {
                                for (t = 0; f > t; t++) m <<= 1, v == e - 1 ? (v = 0, d.push(n(m)), m = 0) : v++;
                                for (o = u.charCodeAt(0), t = 0; 8 > t; t++) m = m << 1 | 1 & o, v == e - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, o >>= 1
                            } else {
                                for (o = 1, t = 0; f > t; t++) m = m << 1 | o, v == e - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, o = 0;
                                for (o = u.charCodeAt(0), t = 0; 16 > t; t++) m = m << 1 | 1 & o, v == e - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, o >>= 1
                            }
                            0 == --l && (l = Math.pow(2, f), f++), delete s[u]
                        } else
                            for (o = i[u], t = 0; f > t; t++) m = m << 1 | 1 & o, v == e - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, o >>= 1;
                        0 == --l && (l = Math.pow(2, f), f++), i[p] = h++, u = String(c)
                    } if ("" !== u) {
                    if (Object.prototype.hasOwnProperty.call(s, u)) {
                        if (u.charCodeAt(0) < 256) {
                            for (t = 0; f > t; t++) m <<= 1, v == e - 1 ? (v = 0, d.push(n(m)), m = 0) : v++;
                            for (o = u.charCodeAt(0), t = 0; 8 > t; t++) m = m << 1 | 1 & o, v == e - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, o >>= 1
                        } else {
                            for (o = 1, t = 0; f > t; t++) m = m << 1 | o, v == e - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, o = 0;
                            for (o = u.charCodeAt(0), t = 0; 16 > t; t++) m = m << 1 | 1 & o, v == e - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, o >>= 1
                        }
                        0 == --l && (l = Math.pow(2, f), f++), delete s[u]
                    } else
                        for (o = i[u], t = 0; f > t; t++) m = m << 1 | 1 & o, v == e - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, o >>= 1;
                    0 == --l && (l = Math.pow(2, f), f++)
                }
                for (o = 2, t = 0; f > t; t++) m = m << 1 | 1 & o, v == e - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, o >>= 1;
                for (;;) {
                    if (m <<= 1, v == e - 1) {
                        d.push(n(m));
                        break
                    }
                    v++
                }
                return d.join("")
            },
            decompress: function(r) {
                return null == r ? "" : "" == r ? null : a._decompress(r.length, 32768, (function(e) {
                    return r.charCodeAt(e)
                }))
            },
            _decompress: function(r, n, t) {
                var o, a, i, s, c, p, u, l, h = [],
                    f = 4,
                    d = 4,
                    m = 3,
                    v = "",
                    w = [],
                    S = {
                        val: t(0),
                        position: n,
                        index: 1
                    };
                for (a = 0; 3 > a; a += 1) h[a] = a;
                for (s = 0, p = Math.pow(2, 2), u = 1; u != p;) c = S.val & S.position, S.position >>= 1, 0 == S.position && (S.position = n, S.val = t(S.index++)), s |= (c > 0 ? 1 : 0) * u, u <<= 1;
                switch (o = s) {
                    case 0:
                        for (s = 0, p = Math.pow(2, 8), u = 1; u != p;) c = S.val & S.position, S.position >>= 1, 0 == S.position && (S.position = n, S.val = t(S.index++)), s |= (c > 0 ? 1 : 0) * u, u <<= 1;
                        l = e(s);
                        break;
                    case 1:
                        for (s = 0, p = Math.pow(2, 16), u = 1; u != p;) c = S.val & S.position, S.position >>= 1, 0 == S.position && (S.position = n, S.val = t(S.index++)), s |= (c > 0 ? 1 : 0) * u, u <<= 1;
                        l = e(s);
                        break;
                    case 2:
                        return ""
                }
                for (h[3] = l, i = l, w.push(l);;) {
                    if (S.index > r) return "";
                    for (s = 0, p = Math.pow(2, m), u = 1; u != p;) c = S.val & S.position, S.position >>= 1, 0 == S.position && (S.position = n, S.val = t(S.index++)), s |= (c > 0 ? 1 : 0) * u, u <<= 1;
                    switch (l = s) {
                        case 0:
                            for (s = 0, p = Math.pow(2, 8), u = 1; u != p;) c = S.val & S.position, S.position >>= 1, 0 == S.position && (S.position = n, S.val = t(S.index++)), s |= (c > 0 ? 1 : 0) * u, u <<= 1;
                            h[d++] = e(s), l = d - 1, f--;
                            break;
                        case 1:
                            for (s = 0, p = Math.pow(2, 16), u = 1; u != p;) c = S.val & S.position, S.position >>= 1, 0 == S.position && (S.position = n, S.val = t(S.index++)), s |= (c > 0 ? 1 : 0) * u, u <<= 1;
                            h[d++] = e(s), l = d - 1, f--;
                            break;
                        case 2:
                            return w.join("")
                    }
                    if (0 == f && (f = Math.pow(2, m), m++), h[l]) v = h[l];
                    else {
                        if (l !== d) return null;
                        v = i + i.charAt(0)
                    }
                    w.push(v), h[d++] = i + v.charAt(0), i = v, 0 == --f && (f = Math.pow(2, m), m++)
                }
            }
        };
    return a
}();
"function" == typeof define && define.amd ? define((function() {
    return LZString
})) : "undefined" != typeof module && null != module && (module.exports = LZString);
var $script = $("script#kb-share");
var KB_BASKET_KEY = $script.attr("kb-basket-key");
var KB_DESIGN_HASH = $script.attr("kb-design-hash");
var KB_SHARE_UTM = $script.attr("kb-share-utm");
var KB_SHARE_UTM_COPY = $script.attr("kb-share-utm-copy");
var SHARE_DESIGN_KEY = "share";
var parseQueryString = function(r) {
    var e;
    if ("" === (e = -1 !== r.indexOf("?") ? r.substring(r.indexOf("?") + 1) : r)) return null;
    var n = {};
    var t, o, a, i;
    for (a = 0, i = (t = e.split("&")).length; a < i; a++) n[(o = t[a].split("="))[0]] = o[1];
    return n
};
var createQueryFromObject = function(r) {
    var e = "";
    for (var n in r) r.hasOwnProperty(n) && (e = e + ("" === e ? "?" : "&") + n + "=" + r[n]);
    return e
};
var daysBetween = function(r, e) {
    const n = 24 * 60 * 60 * 1e3;
    return Math.round(Math.abs((r - e) / n))
};
window.createKbShareLink = window.createKbShareLink || function(r = !0) {
    var e = parseQueryString(window.location.hash);
    var n = JSON.parse(localStorage[KB_BASKET_KEY]);
    if (!n) return console.error("Could not find KitBuilder basket in local storage. Sharing not available."), void 0;
    var t = n[e.basketIndex];
    var o = {
        timestamp: (new Date).toISOString(),
        designId: t.designId,
        designData: t
    };
    var a = JSON.stringify(o);    
    var i = LZString.compressToBase64(a);    
    var s = window.location.origin + window.location.pathname + "?" + SHARE_DESIGN_KEY + "=" + i;
    return  s
};
var query = parseQueryString(window.location.search);
if (query && query[SHARE_DESIGN_KEY]) {
    var cQueryDK = query[SHARE_DESIGN_KEY].replaceAll('%20','+').replaceAll('%2F','/').replaceAll('%3D','=');
    var shareString = LZString.decompressFromBase64(cQueryDK);
    delete query[SHARE_DESIGN_KEY];
    var newQuery = createQueryFromObject(query);
    var shareData = JSON.parse(shareString);
    var kbBasketString = localStorage[KB_BASKET_KEY];
    var kbBasket;
    (kbBasket = kbBasketString ? JSON.parse(kbBasketString) : []).push(shareData.designData), localStorage[KB_BASKET_KEY] = JSON.stringify(kbBasket);
    var basketIndex = kbBasket.length - 1;
    var hashWithQuery = KB_DESIGN_HASH + shareData.designId + "?basketIndex=" + basketIndex;
    var newUrl = window.location.origin + window.location.pathname + newQuery + hashWithQuery;
    window.history.replaceState ? window.history.replaceState({
        path: newUrl
    }, "", newUrl) : window.location.href = newUrl;
    const r = undefined;
    const e = daysBetween(new Date(shareData.timestamp), new Date);
    if (e >= Number("14")) {
        const r = $("#old-share-link-popup");
        r.html(r.html().replace("[[days]]", e)), $.magnificPopup.open({
            items: {
                src: r,
                type: "inline"
            },
            modal: !0,
            fixedContentPos: !0,
            callbacks: {
                open: function() {
                    $(".popup-modal-dismiss").on("click", (function(r) {
                        r.preventDefault(), $.magnificPopup.close()
                    }))
                }
            }
        })
    }
}